<template>
<v-container mt-0 pa-0 text-xs-center>
<v-layout>
  <iframe width="1200px" height="900px" src="https://datastudio.google.com/embed/reporting/1TfDQCmrFVTOZXfCe5h78CRc25vMzOuBJ/page/zyL0" frameborder="0"
        style="border:0;" allowfullscreen></iframe>
</v-layout>
</v-container>
</template>

<script>
import moment from 'moment/moment'
import BarChart from '@/components/Chart/BarChart'
import LineChart from '@/components/Chart/LineChart'
import {Util} from '../Util'
import Districts from '../Model/Districts'

export default {
  mixins: [Districts],
  components: {
    BarChart,
    LineChart
  },
  data () {
    return {
      searchDistrict: '',
      searchCharger: '',
      districtsArray: [],
      numCharge: [],
      timeCharge: [],
      valueCharge: [],
      loading: {main: false, plugStatus: false, plugReports: false, chargerReports: false},
      searchMonth: moment().format('YYYY-MM')
    }
  },

  computed: {
    start () {
      return moment(this.searchMonth).startOf('month').format('YYYY-MM-DD')
    },
    end () {
      return moment(this.start).startOf('month').add(5, 'days').format('YYYY-MM-DD')
    },
    /*
    districtsArray () {
      if (this.districts) {
        return [...this.districts.values()]
      } else {
        return []
      }
    },
    */
    selectedDistrictChargers () {
      try {
        if (this.searchDistrict) {
          return [...this.districts.get(this.searchDistrict).chargers.values()]
        }

        return []
      } catch (e) {
        console.log(e)
        return []
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.$_getData()
    },
    searchDistrict (to, from) {
      this.$_buildData()
    },
    searchCharger (to, from) {
      this.$_buildData()
    }
  },
  created () {
    this.$emit('title', '충전 통계')
    this.$_getData()
  },
  methods: {
    // 충전기 중심일 경우
    async $_getData () {
      this.loading.main = true

      this.numCharge = null
      this.timeCharge = null
      this.valueCharge = null
      this.plugReports = null

      const plugs = await this.$_getPlugs() // $_getCharger() 가 완료되면
      // this.$_setPlugs(plugs)

      this.$_getPlugReports(plugs, () => {
        this.$_buildData()
      })

      const places = await this.$_getPlaces()
      this.districts = await this.$_getDistricts(places)
      this.$_setPlaces(this.districts, places)
      this.districtsArray = [...this.districts.keys()]
      this.districtsArray.sort()

      const chargers = await this.$_getChargers()
      this.$_setChargers(this.districts, chargers)

      this.loading.main = false
    },
    async $_getReports () {
      const plugs = await this.$_getPlugs() // $_getCharger() 가 완료되면
      this.$_getPlugReports(plugs, () => {
        this.$_buildData()
      })
    },
    $_buildData () {
      let numCharge = null
      let timeCharge = null
      let valueCharge = null

      this.numCharge = numCharge
      this.timeCharge = timeCharge
      this.valueCharge = valueCharge

      for (let report of this.plugReports) {
        if (this.searchCharger) {
          if (report.chargerRef) {
            if (report.chargerRef.id !== this.searchCharger) {
              continue
            }
          } else {
            continue
          }
        } else if (this.searchDistrict) {
          if (report.placeRef) {
            if (!this.districts
              .get(this.searchDistrict)
              .places
              .has(report.placeRef.id)) {
              continue
            }
          } else {
            continue
          }
        }

        const createdDate = moment(report.created.toDate()).date() - 1

        if (numCharge === null) {
          numCharge = this.$_createValueArray()
        }
        numCharge[createdDate] += 1

        if (timeCharge === null) {
          timeCharge = this.$_createValueArray()
        }
        timeCharge[createdDate] += report.duration

        if (valueCharge === null) {
          valueCharge = this.$_createValueArray()
        }
        valueCharge[createdDate] += report.wh
      }

      this.numCharge = numCharge
      this.timeCharge = timeCharge
      this.valueCharge = valueCharge
    },
    $_getPlugReports (plugs, callback) {
      this.plugReports = []
      this.$_buildData()
      this.$_getPlugReportsStartAfter(plugs, null, callback)
    },

    $_getPlugReportsStartAfter (plugs, startAfter, callback) {
      this.loading.plugReports = true

      const limit = 2000

      let query = this.$fs
        .collection('plug_reports')
        .where('group', '==', this.$store.state.session.group)
        .where('created', '>=', moment(this.searchMonth, 'YYYY-MM').startOf('month').toDate())
        .where('created', '<=', moment(this.searchMonth, 'YYYY-MM').endOf('month').toDate())
        .orderBy('created', 'asc')

      if (startAfter) {
        query = query.startAfter(startAfter.created)
      }

      query
        .limit(limit)
        .get()
        .then((querySnapshot) => {
          let lastReport = null
          querySnapshot.forEach(doc => {
            const report = doc.data()
            delete report.logs

            const {values, duration, wh} = Util.Plug.parseValue(report.values)
            report.values = values
            report.duration = duration
            report.wh = wh

            if (this.plugReports == null) {
              this.plugReports = []
            }

            this.plugReports.push(report)

            lastReport = report
          })

          this.loading.plugReports = false

          if (querySnapshot.size >= limit) {
            this.$_getPlugReportsStartAfter(plugs, lastReport, callback)
            callback()
          } else {
            callback()
          }
        })
        .catch(error => {
          if (error) {
            // TODO 오류 처리
            console.log(error)
          }

          this.loading.plugReports = false
        })
    },
    $_createValueArray () {
      const now = moment()
      const arr = new Array(moment(this.searchMonth, 'YYYY-MM').daysInMonth()).fill(null)

      if (this.searchMonth === moment().format('YYYY-MM')) {
        arr.fill(0, 0, parseInt(moment().format('D'), 10) - 1)
      } else if (moment(this.searchMonth, 'YYYY-MM').isBefore(now)) {
        arr.fill(0)
      }

      return arr
    },
    $_createChartData (data, secondDatas) {
      if (data) {
        const labels = data.map((a, b) => (b + 1) + '일')
        /*
        let second

        if (secondDatas) {
          second = {
            borderColor: this.$vuetify.theme.warning,
            backgroundColor: this.$vuetify.theme.warning,
            fill: false,
            data: secondDatas
          }
        }

        return {
          labels,
          datasets: [{
            borderColor: this.$vuetify.theme.primary,
            backgroundColor: this.$vuetify.theme.primary,
            fill: false,
            data
          }, second]
        }
        */

        return {
          labels,
          datasets: [{
            borderColor: this.$vuetify.theme.primary,
            backgroundColor: this.$vuetify.theme.primary,
            fill: false,
            data
          }]
        }
      }
    },

    $_getDailySummary (date) {
      if (this.searchMonth !== moment(date).format('YYYY-MM')) { // 해당 월께 아니면 나오지 않게
        return ''
      }

      const mDate = moment(date, 'YYYY-MM-DD')
      const dateIndex = mDate.get('date') - 1

      try {
        let summary = ''

        if (this.numCharge && this.numCharge[dateIndex]) {
          // summary += `횟수 : ${this.numCharge[dateIndex]} 회<br>`
          summary += `${this.numCharge[dateIndex]} 회<br>`
        }

        if (this.timeCharge && this.timeCharge[dateIndex]) {
          // summary += `시간 : ${this.timeCharge[dateIndex]} 분<br>`
          summary += `${this.timeCharge[dateIndex]} 분<br>`
        }

        if (this.valueCharge && this.valueCharge[dateIndex]) {
          // summary += `전력 : ${this.valueCharge[dateIndex]} Wh<br>`
          summary += (this.valueCharge[dateIndex] / 1000).toFixed(2) + ` kWh<br>`
        }

        return summary
      } catch (e) {
        console.log(e)
        return ''
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chart {
  height: 260px
}
</style>



// WEBPACK FOOTER //
// src/components/Charger/ChargerReport.vue